import {useBasketStore, useProductStore} from '../store/hooks/useStore'
import { Hit } from '../store/ProductStore'
import {ALCOHOL_PRODUCT_CLASS} from '../utils/constants'

export const useAlcoholRestrictions = () => {
  const {basket} = useBasketStore()
  const productStore = useProductStore()

  const checkIfProductAlcohol = (product: Hit) => {
    if (Array.isArray(product.bundledProducts)) {
      const productIds = product.bundledProducts.map((bundledProduct) => bundledProduct.id)
      productStore.fetchProducts(productIds, false)
      return product.bundledProducts.some((bundledProduct) => {
        const product = productStore.productsById[bundledProduct.id]
        return !!product?.productClasses?.includes?.(ALCOHOL_PRODUCT_CLASS)
      })
    }
    return !!product.productClasses?.includes?.(ALCOHOL_PRODUCT_CLASS)
  }

  const isCurrentSlotAlcoholRestricted =
    !!basket?.c_restrictedProductClass?.includes?.(ALCOHOL_PRODUCT_CLASS)

  const checkIfAnyProductsAreAlcohol = (products: Hit[]) => {
    return products.filter((product) => checkIfProductAlcohol(product)).length > 0
  }

  return {
    isCurrentSlotAlcoholRestricted,
    checkIfProductAlcohol,
    checkIfAnyProductsAreAlcohol
  }
}
